module.exports = __webpack_public_path__ + "static/media/banner2.e34020ba.jpg";